import { Request } from '@/classes/Request.ts'

// GET /ajax/family/{family_account_id}/lunch_balances
export const wordwareLunchBalance = async (
  familyAccountId: TFamilyAccountId,
  options?: { signal?: AbortSignal }
) => {
  const response = await new Request().get(
    '/ajax/family/' + familyAccountId + '/lunch_balance',
    options
  )
  return response.data.balance
}
